(function (e) {
      $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
          $('#back-top').addClass('show');
        } else {
          $('#back-top').removeClass('show');
        }
      });
      $('#back-top').click(function () {
        $('body,html').animate({
          scrollTop: 0
        }, 800);
        return false;
      });
    })(jQuery)